import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addError, getCallId } from "../../Redux/UserSlice";
import { backendApi } from "../../services/service";

const ThankYou = ({ languageContent, setPage }) => {
  const dispatch = useDispatch();
  const call_id = useSelector(getCallId);
  const submitApi = async (key, value) => {
    await backendApi(call_id, key, value)
      .then((res) => {
        if (res.data) {
          // setPage("verification");
          console.log(res.data);
        }
      })
      .catch((e) => {
        dispatch(addError(e.message));
        setPage("sorryPage");
      });
  };
  useEffect(() => {
    submitApi("thankyou_page", "open");
  }, []);
  return (
    <>
      <img src="./like.png" alt="Like" />
      <p>{languageContent.thank_you_page.thank_you_title}</p>
      <p>{languageContent.thank_you_page.message1}</p>
    </>
  );
};

export default ThankYou;
